<template>
  <div id="bg">
    <div class="download-image">
      <img src="https://file.kinfriend.com/app/wap/img/download-page.png" style="height: 100%;width:100%" />

      <div class="warp">
        <div class="btn-an" @click="click(1)" key="an" v-if="equipmentType != 2">
          <div class="content">
            <img src="static/icon/a-robot.png" style="width:0.42rem" />
            <div class="text">Android下载</div>
          </div>
        </div>
        <div class="btn-an" @click="click(2)" key="ios" v-if="equipmentType != 1">
          <div class="content">
            <img src="static/icon/iphone.png" style="width:0.42rem" />
            <div class="text">iphone下载</div>
          </div>
        </div>
      </div>
    </div>

    <div class="copy" v-if="isManual">
      <button type="button" class="btn" v-clipboard:copy="copyUrl" v-clipboard:success="onCopy"
        v-clipboard:error="onError">
        复制链接
      </button>
      <p class="msg">请复制到浏览器打开</p>
    </div>

    <div class="weixin-tip" v-if="isWxShow">
      <p>
        <img style="width: 93vw" src="static/img/live_weixin.png" alt="微信打开" />
        <span id="close" title="关闭" class="close" @click="isWx = false">×</span>
      </p>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      schemeData: "",
      isWx: false,
      scheme: "juqin://?",
      immediately: "",
      copyUrl:
        "https://client.kinfriend.com/wap/app/index.html#/download",
      isManual: false,
      isWxShow: false,
    };
  },
  mounted() {
    const ua = navigator.userAgent.toLocaleLowerCase();
    const query = this.$route.query;
    console.log("参数", query);

    if (query.type == "MP-WEIXIN") return (this.isManual = true);
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return (this.isWx = true);
    }


    this.isWx = false;
    this.immediately && this.click();
  },
  computed: {
    equipmentType() {
      var equipmentType = "";
      var agent = navigator.userAgent.toLowerCase();
      var android = agent.indexOf("android");
      var iphone = agent.indexOf("iphone");
      var ipad = agent.indexOf("ipad");
      if (android != -1) {
        // equipmentType = "android";
        equipmentType = 1;

      }
      if (iphone != -1 || ipad != -1) {
        // equipmentType = "ios";
        equipmentType = 2;
      }
      return equipmentType;
    }
  },
  methods: {
    onCopy(e) {
      console.log("复制成功！");
      alert("内容已复制到剪切板！");
    },
    onError(e) {
      console.log("复制失败！");
      alert("抱歉，复制失败！");
    },

    close() {
      this.isWx = false;
    },

    async click(type) {
      let schemeUrl = this.scheme;
      // 每次携带上最新时间戳
      if (schemeUrl) {
        schemeUrl = schemeUrl + this.schemeData;
        schemeUrl += `&schemeTime=${new Date().getTime()}`;
      }
      let storeUrl = "";
      if (type === 2) {
        //IOS
        // if (this.isWx == true) {
        //   const bg = document.getElementById("bg");
        //   bg.style.height = "100vh";
        //   bg.style.overflow = "hidden";
        //   this.isWxShow = true;
        //   return
        // }
        window.open('https://apps.apple.com/cn/app/%E8%81%9A%E4%BA%B2/id1535740004')
        return
      } else {
        //安卓
        if (this.isWx == true) {
          const bg = document.getElementById("bg");
          bg.style.height = "100vh";
          bg.style.overflow = "hidden";
          this.isWxShow = true;
          return
        }

        const response = await this.$request.api.get({ url: this.$api.appVersionLastUrl + '1' })
        const { success, message, code, data } = response

        if (success) {
          storeUrl = data.downloadUrl;
          window.AROUSE.OPEN({ schemeUrl, storeUrl });
        } else {
          alert(message || "最新版本获取失败！");
        }
      }

      window.AROUSE.OPEN({ schemeUrl, storeUrl });
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

.download-image {}

.warp {
  position: absolute;
  top: 470px;
  right: 100px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.btn-an {
  margin-top: 10px;
  width: 240px;
  height: 60px;
  background: rgb(255, 255, 255, 0.6);
  border-radius: 60px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}

/* .btn-ios {
  width: 240px;
  height: 60px;
  background: rgb(255, 255, 255, 0.6);
  border-radius: 60px;
  position: absolute;
  top: 580px;
  right: 90px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
} */
.content {
  display: flex;
  justify-content: center;
  text-align: center;
}

.text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-left: 10px;
}

.copy {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  color: #fff;
  letter-spacing: 2px;
}

.btn {
  width: 450px;
  height: 80px;
  background: transparent;
  border: 1px solid #fff;
  font-size: 30px;
  font-weight: bold;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
}

.weixin-tip {
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  filter: alpha(opacity=80);
  width: 100%;
  height: 100%;
  z-index: 100;
}

.weixin-tip p {
  text-align: center;
  margin-top: 10%;
  padding: 0 5%;
  position: relative;
}
</style>
